<template>
  <div class="user-center-container">
    <div class="main-content">
      <div class="user-info-card">
        <el-card>
          <div slot="header" class="card-header">
            <i class="el-icon-user"></i>
            <span>TA 的个人资料</span>
          </div>
          <div class="user-info">
            <div class="avatar">
              <img :src="userInfo.icon || defaultAvatar" alt="头像" />
            </div>
            <div class="info-list">
              <div class="info-item">
                <span class="label"><i class="el-icon-user"></i> 用户名：</span>
                <span class="value">{{ userInfo.userName }}</span>
              </div>
              <div class="info-item">
                <span class="label"><i class="el-icon-time"></i> 注册时间：</span>
                <span class="value">{{ userInfo.createTime }}</span>
              </div>
              <div class="info-item">
                <span class="label"><i class="el-icon-rank"></i> 用户等级：</span>
                <span class="value">
                  <el-tag :type="getLevelType(userInfo.userLevel)" size="small">
                    {{ userInfo.userLevel }}级
                  </el-tag>
                </span>
              </div>
              <div class="info-actions">
                <el-button 
                  type="primary" 
                  size="small" 
                  plain
                  @click="toggleFollow"
                >
                  {{ isFollowed ? '已关注' : '+ 关注' }}
                </el-button>
                <el-button 
                  type="success" 
                  size="small" 
                  plain
                  @click="openSendMessage"
                >
                  <i class="el-icon-message"></i> 发消息
                </el-button>
              </div>
            </div>
          </div>
        </el-card>
      </div>

      <div class="my-posts-card">
        <el-card>
          <div slot="header" class="card-header">
            <i class="el-icon-document"></i>
            <span>TA 的文章</span>
          </div>
          <div class="filter-bar">
            <CategorySelect 
              v-model="selectedCategory" 
              placeholder="全部分类"
              size="small"
              custom-style="width: 150px; margin-right: 10px;"
              @change="getPostList"
            />
          </div>
          <ul class="post-list">
            <li class="post-item" v-for="post in postList" :key="post.docDigest" @click="goDetail(post.docDigest)">
              <div class="post-content">
                <h4 class="post-title">{{ post.title }}</h4>
                <div class="post-meta">
                  <span><i class="el-icon-time"></i> {{ post.createTime }}</span>
                  <span><i class="el-icon-star-on"></i> {{ post.praiseCount || 0 }} 点赞</span>
                  <span><i class="el-icon-chat-dot-round"></i> {{ post.commentCount || 0 }} 评论</span>
                </div>
              </div>
              <div class="post-action">
                <el-button size="mini" type="text">查看详情</el-button>
              </div>
            </li>
          </ul>
          <el-empty v-if="postList.length === 0 && !loading" description="暂无文章"></el-empty>
          <div class="loading-status" v-if="loading">
            <i class="el-icon-loading"></i>
            <span>加载中...</span>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNumber"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal"
            style="margin-top: 20px; justify-content: flex-end"
          ></el-pagination>
        </el-card>
      </div>
    </div>

    <el-dialog title="发送消息" :visible.sync="sendMessageDialogVisible" width="500px">
      <el-form :model="messageForm" :rules="messageRules" ref="messageForm" label-width="80px">
        <el-form-item label="消息标题" prop="title">
          <el-input v-model="messageForm.title" placeholder="请输入消息标题" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="消息内容" prop="content">
          <el-input 
            v-model="messageForm.content" 
            type="textarea" 
            :rows="6" 
            placeholder="请输入消息内容" 
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="sendMessageDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitSendMessage" :loading="messageLoading">发送</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CategorySelect from '../components/CategorySelect.vue';
export default {
  name: 'OtherUserCenter',
  components: {
    CategorySelect
  },
  data() {
    return {
      userId: '',
      userInfo: {},
      postList: [],
      pageNumber: 1,
      pageSize: 10,
      pageTotal: 0,
      selectedCategory: 0,
      loading: false,
      defaultAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      isFollowed: false,
      sendMessageDialogVisible: false,
      messageForm: {
        title: '',
        content: ''
      },
      messageRules: {
        title: [{ required: true, message: '请输入消息标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入消息内容', trigger: 'blur' }]
      },
      messageLoading: false
    };
  },
  created() {
    this.userId = this.$route.params.userId;
    if (this.userId) {
      this.getUserInfo();
      this.getPostList();
      this.checkIsFollowing();
    }
  },
  methods: {
    async getUserInfo() {
      try {
        const response = await this.$axios({
          method: 'post',
          url: '/user/getUserInfoById',
          data: {
            userId: this.userId
          }
        });
        if (response.code === '200' || response.code === 200) {
          this.userInfo = response.data;
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
      }
    },
    getPostList() {
      this.loading = true;
      this.$axios({
        method: 'post',
        url: '/doc/queryUserDocList',
        data: {
          pageNum: this.pageNumber,
          pageSize: this.pageSize,
          order: 'time',
          queryUserId: this.userId,
          state: '1'
        }
      })
        .then(response => {
          this.loading = false;
          if (response.code == 200) {
            this.postList = response.data.data || [];
            this.pageTotal = response.data.total || 0;
          } else {
            this.$message.error(response.msg || '获取文章列表失败');
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          this.$message.error('获取文章列表失败');
        });
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getPostList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNumber = 1;
      this.getPostList();
    },
    goDetail(id) {
      this.$router.push({ name: 'Content', params: { id: id } });
    },
    async checkIsFollowing() {
      const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}');
      if (!loginResult.userId) return;
      
      try {
        const response = await this.$axios({
          method: 'post',
          url: '/userfollow/isFollowed',
          data: {
            userId: loginResult.userId,
            followUserId: this.userId
          }
        });
        
        if (response.code === '200' || response.code === 200) {
          this.isFollowed = response.data || false;
        }
      } catch (error) {
        console.error('检查关注状态失败:', error);
      }
    },
    async toggleFollow() {
      const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}');
      if (!loginResult.userId) {
        this.$message.warning('请先登录');
        this.$router.push({ name: 'Login', query: { redirect: this.$route.fullPath } });
        return;
      }
      
      const url = this.isFollowed ? '/userfollow/unfollow' : '/userfollow/follow';
      try {
        const response = await this.$axios({
          method: 'post',
          url: url,
          data: {
            userId: loginResult.userId,
            followUserId: this.userId
          }
        });
        
        if (response.code === '200' || response.code === 200) {
          this.$message.success(this.isFollowed ? '取消关注成功' : '关注成功');
          this.isFollowed = !this.isFollowed;
        } else {
          this.$message.error(response.msg || '操作失败');
        }
      } catch (error) {
        console.error('操作失败:', error);
        this.$message.error('操作失败');
      }
    },
    openSendMessage() {
      const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}');
      if (!loginResult.userId) {
        this.$message.warning('请先登录');
        this.$router.push({ name: 'Login', query: { redirect: this.$route.fullPath } });
        return;
      }
      
      this.messageForm.title = '';
      this.messageForm.content = '';
      this.sendMessageDialogVisible = true;
    },
    submitSendMessage() {
      this.$refs.messageForm.validate(async (valid) => {
        if (!valid) return;
        
        this.messageLoading = true;
        
        try {
          const response = await this.$axios({
            method: 'post',
            url: '/message/sendSystem',
            data: {
              receiverId: this.userId,
              title: this.messageForm.title,
              content: this.messageForm.content
            }
          });
          
          if (response.code === '200') {
            this.$message.success('消息发送成功');
            this.sendMessageDialogVisible = false;
          } else {
            this.$message.error(response.msg || '发送失败');
          }
        } catch (error) {
          console.error(error);
          this.$message.error('发送失败');
        } finally {
          this.messageLoading = false;
        }
      });
    },
    getLevelType(level) {
      if (level >= 999) return 'danger';
      if (level >= 100) return 'warning';
      if (level >= 10) return 'success';
      return 'info';
    }
  }
};
</script>

<style scoped lang="less">
.user-center-container {
  min-height: calc(100vh - 64px);
  margin-top: 64px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 24px;

  .main-content {
    max-width: 1200px;
    margin: 0 auto;

    .user-info-card {
      margin-bottom: 24px;

      ::v-deep .el-card {
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);

        .card-header {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 18px;
          font-weight: 600;
          color: #333;

          i {
            color: #667eea;
            font-size: 22px;
          }
        }
      }

      .user-info {
        display: flex;
        gap: 32px;
        padding: 20px;

        .avatar {
          flex-shrink: 0;
          position: relative;
          display: inline-block;

          img {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            object-fit: cover;
            border: 4px solid #667eea;
            box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3);
          }
        }

        .info-list {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 16px;

          .info-item {
            display: flex;
            align-items: center;
            font-size: 15px;

            .label {
              width: 120px;
              color: #666;
              display: flex;
              align-items: center;
              gap: 6px;

              i {
                color: #667eea;
              }
            }

            .value {
              color: #333;
              font-weight: 500;
            }
          }

          .info-actions {
            display: flex;
            gap: 12px;
            margin-top: 16px;
            padding-top: 16px;
            border-top: 1px solid #eee;
          }
        }
      }
    }

    .my-posts-card {
      ::v-deep .el-card {
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);

        .card-header {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 18px;
          font-weight: 600;
          color: #333;

          i {
            color: #667eea;
            font-size: 22px;
          }
        }
      }

      .filter-bar {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding: 16px;
        background: #f8f9fa;
        border-radius: 8px;
      }

      .post-list {
        list-style: none;
        padding: 0;
        margin: 0;

        .post-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px;
          margin-bottom: 16px;
          background: #fff;
          border: 1px solid #e8e8e8;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            border-color: #667eea;
            box-shadow: 0 4px 16px rgba(102, 126, 234, 0.15);
            transform: translateY(-2px);
          }

          .post-content {
            flex: 1;

            .post-title {
              margin: 0 0 12px;
              font-size: 16px;
              font-weight: 600;
              color: #333;
            }

            .post-meta {
              display: flex;
              gap: 20px;
              font-size: 13px;
              color: #999;

              span {
                display: flex;
                align-items: center;
                gap: 4px;

                i {
                  color: #667eea;
                }
              }
            }
          }

          .post-action {
            flex-shrink: 0;
            margin-left: 20px;
          }
        }
      }

      .loading-status {
        text-align: center;
        padding: 20px;
        color: #999;
        font-size: 14px;

        i {
          margin-right: 8px;
        }
      }

      ::v-deep .el-pagination {
        .el-pager li {
          border-radius: 6px;
          min-width: 36px;
          height: 36px;
          line-height: 36px;
          font-weight: 500;

          &.active {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: #fff;
          }

          &:hover {
            background: #667eea;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
